"use client"
import React, { useState } from "react";
import Link from "next/link"
import { usePathname } from "next/navigation";
import ChevronDownIcon from "@/assets/icon/chevron-down.svg";

export default function NavMainLink({href, children} : {href:string, children:React.ReactNode}) {
  const pathname = usePathname();
  return <Link className={`main-nav-item ${pathname === href ? "main-nav-item--active" : ""}`} href={href}>
    <div className="main-nav-item__label">
      <div className="main-nav-item__label__content">
        {children}
      </div>
    </div>
  </Link>
}

export function NavMainDropdown({dropdownMenu, children} : {dropdownMenu: React.ReactNode, children:React.ReactNode}) {
  const pathname = usePathname();
  const [showDropdown, setShowDropdown] = useState<boolean>(pathname.indexOf("/team/") >= 0)
  return (
    <>
      <button className={`main-nav-item`} onClick={() => setShowDropdown(!showDropdown)}>
        <div className="main-nav-item__label">
          <div className="main-nav-item__label__content">
            {children}
          </div>
          <ChevronDownIcon className="text-xs hidden lg:block" />
        </div>
      </button>
      <div className={`${showDropdown ? 'lg:block' : 'lg:hidden'}`}>
        {dropdownMenu}
      </div>
    </>

  )
}
